import { render, staticRenderFns } from "./companyXq.vue?vue&type=template&id=283e5b45&scoped=true"
import script from "./companyXq.vue?vue&type=script&lang=js"
export * from "./companyXq.vue?vue&type=script&lang=js"
import style0 from "./companyXq.vue?vue&type=style&index=0&id=283e5b45&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "283e5b45",
  null
  
)

export default component.exports